/** Incremental catalog pull while POS is focused (two-device freshness). */
export const POS_LIVE_CATALOG_PROBE_INTERVAL_MS = 30_000;

export function shouldRunPosLiveCatalogProbe(args: {
  isFocused: boolean;
  isVisible: boolean;
  isOnline: boolean;
}): boolean {
  return args.isFocused && args.isVisible && args.isOnline;
}
